"use strict";
angular.module('appMarketplace')
    .service('CommonService', ['$timeout', 'NotificationService', function ($timeout, NotificationService) {
        var service = this;

        service.getErrorCallback = function (promiseHolder, errorMessage) {
            return function () {
                NotificationService.showErrorMessage(errorMessage);
                promiseHolder.reject(errorMessage);
            }
        };

        service.shakeInput = function (element, distance) {
            distance = distance || 10;
            element.effect("shake", {distance: distance});
        };

        var entityMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };

        service.escapeHtml = function escapeHtml(string) {
            return String(string).replace(/[&<>"'`=\/]/g, function (s) {
                return entityMap[s];
            });
        };

        /**
         * Displays a validation error on a specific input.
         *
         * @param validationErrors - dictionary, where keys are field names and values are error text
         * @param errorTemplate
         * @param container - optional parameter. Container where to search for fields.
         */
        service.displayValidationErrors = function (validationErrors, errorTemplate, container) {
            if (!validationErrors) {
                return;
            }
            if (!container) {
                container = angular.element("body");
            }
            angular.forEach(validationErrors, function (value, key) {
                var element = container.find("[data-for='" + key + "']");
                var invalidInput = container.find("[name='" + key + "']")
                    .parents(".validated-control") //going upwards because elements like datepicker can have wrappers
                    .andSelf(); //input that will be highlighted by validator
                if (!element.length || !invalidInput.length) {
                    NotificationService.showErrorMessage('Field ' + key + ': ' + value);
                }
                invalidInput.removeClass("k-valid");
                invalidInput.addClass("k-invalid");
                invalidInput.attr('aria-invalid', true);
                var newElement = angular.element(errorTemplate({field: key, message: value}));
                newElement = newElement
                    .attr("data-for", key) //set data-for for template, so it can be later reused by kendo validator
                    .addClass("k-invalid-msg");
                element.replaceWith(newElement);
                newElement.show();
            })
        };

        service.resetValidationErrors = function (container) {
            if (!container) {
                container = angular.element("body");
            }

            container.find(".k-invalid-msg").html("").hide();
            container.find(".k-invalid").removeClass("k-invalid").addClass("k-valid");
        };

        service.showProgressPanel = function (selector, fixed) {
            var element = angular.element(selector || "#content");
            service.progress(element, true);
            $timeout(function () {
                if (fixed === undefined || fixed) {
                    element.find('.k-loading-mask').css('position', 'fixed').css('z-index', '12000').css('top', '0').css('left', '0'); // session-expired-directive defines z-index of session-expired window of 12001
                }
            });
        };

        service.hideProgressPanel = function (selector) {
            service.progress(angular.element(selector || "#content"), false);
        };

        // copied from kendo.ui.progress and changed prependTo to appendTo
        service.progress = function(element, show) {
            var mask = element.find(".k-loading-mask");

            if (show) {
                if (mask.length) {
                    // already displayed
                    return;
                }

                var kendoSupport = kendo.support;
                var browser = kendoSupport.browser;
                var rtl = kendoSupport.isRtl(element);
                var positionX = rtl ? "right" : "left";
                var scrollLeft = element.scrollLeft();
                var i = browser.webkit && rtl ? element[0].scrollWidth - element.width() - 2 * scrollLeft : 0;

                angular.element("<div class='k-loading-mask'><span class='k-loading-text'>" + kendo.ui.progress.messages.loading + "</span><div class='k-loading-image'/><div class='k-loading-color'/></div>")
                    .width("100%")
                    .height("100%")
                    .css("top", element.scrollTop())
                    .css(positionX, Math.abs(scrollLeft) + i)
                    .appendTo(element)
            } else {
                mask && mask.remove();
            }
        };

        service.appendObjectToFormData = function (object, formData, namespace) {
            var formKey;
            for (var property in object) {
                if (object.hasOwnProperty(property)) {
                    if (namespace) {
                        formKey = namespace + '[' + property + ']';
                    } else {
                        formKey = property;
                    }
                    // if the property is an object, but not a File and not an array,
                    // use recursion.
                    if (typeof object[property] === 'object' && !Array.isArray(object[property]) && !(object[property] instanceof File)) {
                        service.appendObjectToFormData(object[property], formData, property);
                    } else if (Array.isArray(object[property])) {
                        service.appendArrayToFormData(object[property], formKey, formData);
                    } else {
                        // if it's a string or a File object
                        formData.append(formKey, object[property]);
                    }
                }
            }
            return formData;
        };

        service.appendArrayToFormData = function (array, formKey, formData) {
            var namespace;
            var field;
            for (var i = 0; i < array.length; i++) {
                namespace = formKey + '[' + i + ']';
                if (array[i] && typeof array[i] === 'object') {
                    for (var property in array[i]) {
                        if (array[i].hasOwnProperty(property)) {
                            field = namespace + '.' + property;
                            // if the property is an object, but not a File,
                            // use recursivity.
                            if (array[i][property] && typeof array[i][property] === 'object' && !(array[i][property] instanceof File)) {
                                service.appendObjectToFormData(array[i][property], formData, field);
                            } else {
                                // if it's a string or a File object
                                formData.append(field, array[i][property]);
                            }
                        }
                    }
                } else {
                    formData.append(namespace, array[i]);
                }
            }
        };

        service.getObjectValuesAsArray = function (object) {
            var resultArray = [];

            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    resultArray.push(object[key]);
                }
            }

            return resultArray;
        };

        service.getObjectValuesAsArray = function (object) {
            var resultArray = [];

            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    resultArray.push(object[key]);
                }
            }

            return resultArray;
        };
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/common-service.js
// module id = 46
// module chunks = 37